export const AUTHENTICATED_USER='authenticated/user'
export const AUTHENTICATED_USER_PASSWORD='authenticated/userpassword'